"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLinkControl = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _utils = require("../../utils");

var _interfaces = require("../interfaces");

var useLinkControl = function useLinkControl(editorInstance, setModalToMount) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isLinkModalOpen = _useState2[0],
      setIsLinkModalOpen = _useState2[1];

  var toggleUrl = (0, _react.useCallback)(function (url) {
    if (editorInstance) {
      editorInstance.commands.link.toggle(url);
      setIsLinkModalOpen(false);
    }
  }, [editorInstance]);
  var openLinkModal = (0, _react.useCallback)(function () {
    setIsLinkModalOpen(true);
    setModalToMount(_interfaces.RTEModals.Link);
  }, [setModalToMount]);
  var closeLinkModal = (0, _react.useCallback)(function () {
    setIsLinkModalOpen(false);
  }, []);
  var canOpenLinkModal = (0, _react.useRef)(false);
  var isEditorFocused = editorInstance && editorInstance.isFocused();
  canOpenLinkModal.current = !!isEditorFocused && !isLinkModalOpen;
  (0, _react.useEffect)(function () {
    var handler = function handler(event) {
      // Cmd+K/Ctrl+K to open link modal
      var matchLinkShortcuts = event.keyCode === _utils.EventKeyCodes.K && (event.metaKey || event.ctrlKey);

      if (canOpenLinkModal.current && matchLinkShortcuts) {
        event.preventDefault();
        openLinkModal();
      }
    };

    document.addEventListener('keydown', handler);
    return function () {
      return document.removeEventListener('keydown', handler);
    };
  }, [openLinkModal]);
  return {
    isLinkModalOpen: isLinkModalOpen,
    openLinkModal: openLinkModal,
    closeLinkModal: closeLinkModal,
    toggleUrl: toggleUrl
  };
};

exports.useLinkControl = useLinkControl;